<h1 mat-dialog-title>{{ data.promptKey | translate: data.promptParams }}</h1>
@if (!!data.messageKey) {
    <mat-dialog-content>
        @let message = data.isMessageTranslated ? data.messageKey : (data.messageKey | translate: data.messageParams);
        @if (data.isMessageHTML) {
            <div [innerHTML]="message"></div>
        } @else {
            {{ message }}
        }
    </mat-dialog-content>
}
<mat-dialog-actions align="end">
    @switch (data.buttonConfiguration) {
        @case (DialogButtonConfigurationEnum.DeleteCancel) {
            <button mat-stroked-button [mat-dialog-close]="false">{{ 'General.Cancel' | translate }}</button>
            <button mat-flat-button color="warn" [mat-dialog-close]="true">
                <mat-icon>delete</mat-icon>
                {{ 'General.Delete' | translate }}
            </button>
        }
        @case (DialogButtonConfigurationEnum.ConfirmCancel) {
            <button mat-stroked-button [mat-dialog-close]="false">{{ 'General.Cancel' | translate }}</button>
            <button mat-flat-button color="primary" [mat-dialog-close]="true">
                <mat-icon>check</mat-icon>
                {{ 'Alert.ConfirmButtonText' | translate }}
            </button>
        }
        @case (DialogButtonConfigurationEnum.Ok) {
            <button mat-flat-button color="primary" [mat-dialog-close]="true">
                <mat-icon>check</mat-icon>
                {{ 'General.Ok' | translate }}
            </button>
        }
        @default {
            <button mat-stroked-button cdkFocusInitial [mat-dialog-close]="false">{{ 'General.No' | translate }}</button>
            <button mat-flat-button color="primary" [mat-dialog-close]="true">{{ 'General.Yes' | translate }}</button>
        }
    }
</mat-dialog-actions>
